"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));

var _core = require("@material-ui/core");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _SearchBarModule = _interopRequireDefault(require("./SearchBar.module.scss"));

var _excluded = ["placeholder", "handleSearch", "onChange", "onFocus", "onBlur", "value", "handleClear", "forceFocus", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Search bar
 * Simple Foodbomb Search Bar Component
 *
 * ## PropTypes:
 * ```js
 * SearchBar.propTypes = {
 *   handleSearch: PropTypes.func.isRequired,
 *   onChange: PropTypes.func.isRequired,
 *   value: PropTypes.string,
 *   onFocus: PropTypes.func,
 *   onBlur: PropTypes.func,
 *   placeholder: PropTypes.string,
 *   classes: PropTypes.shape({
 *     searchBar: PropTypes.string,
 *     inputRoot: PropTypes.string,
 *     inputInput: PropTypes.string,
 *     searchButton: PropTypes.string,
 *     searchForm: PropTypes.string,
 *   }),
 *   handleClear: PropTypes.func,
 *   forceFocus: PropTypes.bool,
 * };
 * ```
 */
var SearchBar = function SearchBar(_ref) {
  var placeholder = _ref.placeholder,
      handleSearch = _ref.handleSearch,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      value = _ref.value,
      handleClear = _ref.handleClear,
      forceFocus = _ref.forceFocus,
      classes = _ref.classes,
      props = _objectWithoutProperties(_ref, _excluded);

  // Classes you can pass in classes object -> searchBar, inputRoot, inputInput, searchButton, searchForm
  var SearchBarStyles = [_SearchBarModule.default.SearchBar];
  var InputRootStyles = [_SearchBarModule.default.Input__root];
  var InputInputStyles = [_SearchBarModule.default.Input__input];
  var SearchButtonStyles = [_SearchBarModule.default.SearchBar__SearchBtn];
  var SearchFormStyles = [_SearchBarModule.default.SearchBarForm];
  var searchInputElem = (0, _react.useRef)();
  var searchFormElem = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (forceFocus) {
      searchInputElem.current.focus();
    }
  }, [forceFocus]);

  if (classes) {
    SearchBarStyles.push(classes.searchBar);
    InputRootStyles.push(classes.inputRoot);
    InputInputStyles.push(classes.inputInput);
    SearchButtonStyles.push(classes.searchButton);
    SearchFormStyles.push(classes.searchForm);
  }

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    searchInputElem.current.blur();
    handleSearch();
  };

  var handleClearAndRefocus = function handleClearAndRefocus() {
    handleClear();
    searchInputElem.current.focus();
  }; // Note: as of React 17, focus and blur events arent able to be tested with our current Jest implementation


  var handleOnFocus = function handleOnFocus() {
    if (onFocus) {
      onFocus();
    }

    searchFormElem.current.classList.add(_SearchBarModule.default.active);
  }; // Note: as of React 17, focus and blur events arent able to be tested with our current Jest implementation


  var handleOnBlur = function handleOnBlur() {
    if (onBlur) {
      onBlur();
    }

    searchFormElem.current.classList.remove(_SearchBarModule.default.active);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: SearchBarStyles.join(' ')
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    acceptCharset: "utf-8",
    action: "#",
    className: SearchFormStyles.join(' '),
    ref: searchFormElem,
    autoComplete: "off"
  }, /*#__PURE__*/_react.default.createElement(_core.InputBase, _extends({
    fullWidth: true,
    value: value,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    placeholder: placeholder,
    classes: {
      root: InputRootStyles.join(' '),
      input: InputInputStyles.join(' ')
    },
    type: "search",
    inputProps: {
      'aria-label': 'Search product, category or wholesaler',
      ref: searchInputElem
    },
    onChange: onChange
  }, props)), /*#__PURE__*/_react.default.createElement(_HighlightOff.default, {
    className: value && handleClear ? [_SearchBarModule.default.SearchBar__ClearIcon, _SearchBarModule.default.show].join(' ') : _SearchBarModule.default.SearchBar__ClearIcon,
    onClick: handleClearAndRefocus
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "secondary",
    onClick: handleSearch,
    className: SearchButtonStyles.join(' ')
  }, /*#__PURE__*/_react.default.createElement(_Search.default, null))));
};

SearchBar.propTypes = {
  handleSearch: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.string,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  classes: _propTypes.default.shape({
    searchBar: _propTypes.default.string,
    inputRoot: _propTypes.default.string,
    inputInput: _propTypes.default.string,
    searchButton: _propTypes.default.string,
    searchForm: _propTypes.default.string
  }),
  handleClear: _propTypes.default.func,
  forceFocus: _propTypes.default.bool
};
var _default = SearchBar;
exports.default = _default;

//# sourceMappingURL=SearchBar.js.map